import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Row, Col,Typography,Anchor,Layout  } from 'antd';
import 'antd/dist/antd.css';

class AppLayout extends Component {
 state= { }
    render() { 
        const {children} = this.props;
        const { Content } = Layout;
        return ( 
            <React.Fragment>
               <div className='main'>
               <Content>{children}</Content>       
               </div>  
            </React.Fragment>
         );
    }
}
 
export default AppLayout;